var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-badge',{staticClass:"bk-badge",attrs:{"bordered":_vm.bordered,"bottom":_vm.bottom,"color":_vm.color,"offset-x":_vm.offsetX,"offset-y":_vm.offsetY,"value":_vm.value}},[_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_vm._t("badge")],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }